import { useEffect, useRef, useState } from "react";
import { Check, Globe, Loader2 } from "lucide-react";
import { LANGUAGES } from "@/i18n/languages";
import { useLanguage } from "@/i18n/LanguageContext";

export const LanguagePicker = ({ mobile = false }) => {
  const { lang, setLang, loading } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className={`relative ${mobile ? "w-full" : ""}`} ref={ref}>
      <button
        data-testid="lang-toggle"
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-1.5 rounded-full border border-purple-500/30 bg-[#0E0E16] text-gray-300 transition-colors hover:border-[#14F195]/60 hover:text-[#14F195] ${
          mobile ? "w-full justify-center px-4 py-2.5" : "px-3 py-1.5"
        }`}
        aria-label="Change language"
      >
        {loading ? (
          <Loader2 size={14} className="animate-spin" />
        ) : (
          <Globe size={14} />
        )}
        <span className="font-display text-xs font-bold uppercase">
          {current.code}
        </span>
      </button>

      {open && (
        <div
          data-testid="lang-menu"
          className={`absolute right-0 top-full z-50 mt-2 max-h-72 w-48 overflow-y-auto rounded-2xl border border-purple-500/30 bg-[#0E0E16] p-1.5 shadow-[0_20px_60px_rgba(0,0,0,0.6)] ${
            mobile ? "left-0 right-0 w-full" : ""
          }`}
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className="flex w-full items-center justify-between rounded-xl px-3 py-2 text-left text-sm text-gray-200 transition-colors hover:bg-[#14141E] hover:text-[#14F195]"
            >
              <span>{l.name}</span>
              {lang === l.code && <Check size={14} className="text-[#14F195]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
